export default {
  LIST: "list",
  MONTH: "month"
};
